import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext.js';
import { Avatar, AvatarFallback } from '@/components/ui/avatar.js';
import { Button } from '@/components/ui/button.js';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.js';
import { LogOut, Brain } from 'lucide-react';
// DISABLED: Theme toggle moved to sidebar
// import { useTheme } from '@/contexts/ThemeContext.js';
import { MemoriesModal } from '@/components/memories/MemoriesModal.js';

export function UserMenu() {
  const { user, signOut } = useAuth();
  // DISABLED: Theme toggle moved to sidebar
  // const { theme, setTheme, effectiveTheme } = useTheme();
  const [showMemoriesModal, setShowMemoriesModal] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
      // Force reload to clear state even if signOut fails
      window.location.reload();
    }
  };

  if (!user) return null;

  const userInitials = user.email?.[0]?.toUpperCase() || 'U';

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="relative h-10 w-10 rounded-full">
            <Avatar className="h-10 w-10">
              <AvatarFallback className="bg-primary/10 text-primary font-medium">
                {userInitials}
              </AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <div className="flex items-center justify-start gap-2 p-2">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium">{user.email}</p>
              <p className="text-xs text-muted-foreground">Manage your account</p>
            </div>
          </div>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => setShowMemoriesModal(true)}>
            <Brain className="mr-2 h-4 w-4" />
            Memories
          </DropdownMenuItem>
          {/* DISABLED: Theme toggle moved to sidebar */}
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleSignOut} className="text-destructive focus:text-destructive">
            <LogOut className="mr-2 h-4 w-4" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <MemoriesModal open={showMemoriesModal} onOpenChange={setShowMemoriesModal} />
    </>
  );
}
